<script>
  import View from '@/views/View'
  import LoadSections from '@/mixins/load-sections'

  import solutionsData from '@/data/solutions.json'

  export default {
    name: 'Solutions',

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'solutions-gallery',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'solutions',
      },
    },

    data: () => ({
      // 动态分类标题，由 SolutionsGallery 通过 $root 事件更新
      dynamicCategoryTitle: '',
    }),

    metaInfo() {
      const slugify = (text) => {
        if (!text) return ''
        return text
          .toString()
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
      }
      const title = this.dynamicCategoryTitle || this.$t('solutions.title')
      const description = this.$t('solutions.subtitle')
      const origin = typeof window !== 'undefined' ? window.location.origin : ''
      const items = (solutionsData?.solutions || []).map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.title,
        url: `${origin}/solutions/${item.id}-${slugify(item.title)}`,
        image: item.imgUrl,
      }))
      return {
        title,
        meta: [
          { vmid: 'description', name: 'description', content: description },
        ],
        script: [
          {
            vmid: 'solutions-jsonld',
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org',
              '@type': 'ItemList',
              name: title,
              itemListElement: items,
            },
          },
        ],
      }
    },

    mounted() {
      this._galleryTabHandler = ({ label, isAll }) => {
        this.dynamicCategoryTitle = isAll ? '' : label
      }
      this.$root.$on('gallery-tab-changed', this._galleryTabHandler)
    },

    beforeDestroy() {
      if (this._galleryTabHandler) {
        this.$root.$off('gallery-tab-changed', this._galleryTabHandler)
      }
    },
  }
</script>
